import Api from "@/services/Api";

let controller = "card_backs";

export default {
  attachToInvestigatorSession(cardBackId, investigatorSessionId) {
    return Api().put(`${controller}/${cardBackId}/attach_to_investigator_session`, {
      investigator_id: investigatorSessionId
    });
  }
};
